@if (currentUser) {
  <div class="devices-list mb-2">
    @for (mfa of currentUser.mfaOptions; track mfa.id) {
      <div class="device-card">
        <div class="device-info">
          <span class="device-name">{{ mfa.deviceName }}</span>
          <span class="device-date">{{ mfa.createdAt | date: dateUtilService.dateFormat }}</span>
        </div>
      </div>
    }
  </div>
  @if (currentUser?.mfaOptions?.length > 0) {
    <div class="row">
      <div class="col-12 text-right">
        <gung-button
          classes="btn-danger w-100"
          label="{{ 'DELETE_ALL_MFA' | translate }}"
          [onClick]="deleteAllMfaDevice.bind(this, currentUser.username)"
        />
      </div>
    </div>
  }
}